export default "__VITE_ASSET__ZTTrRFrj__"